import { render } from "./GlobalResponse.vue?vue&type=template&id=207908e5&scoped=true"
import script from "./GlobalResponse.vue?vue&type=script&lang=js"
export * from "./GlobalResponse.vue?vue&type=script&lang=js"

import "./GlobalResponse.vue?vue&type=style&index=0&id=207908e5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207908e5"]])

export default __exports__